import React from "react";
import { Outlet } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

/**
 * Renders its children only for a user holding a TowPay role.
 *
 * This duplicates the check the login screen already makes, on purpose: the login check
 * catches the common case with a useful message, and this one catches a token that was
 * minted before a role was revoked. Without it such a user gets an empty page and a wall of
 * failed fetches instead of an explanation.
 */
export function RequireMerchantAccess({ children }) {
  const { canViewMerchants } = useAuth();

  //  children when wrapped directly, Outlet when used as a layout route.
  if (canViewMerchants) return children ? <>{children}</> : <Outlet />;

  return (
    <div className="alert alert-warning" role="alert">
      This account does not have access to Merchant Management. Contact Autura support.
    </div>
  );
}

export default RequireMerchantAccess;
